/**
 * Lazy locale loader: base `<lang>.json` deep-merged with every
 * `fragments/<area>/<lang>.json` (see README.md in this folder).
 *
 * Vite turns each glob match into its own async chunk, so only the files of
 * the requested language are fetched (plus the `tr` fallback, which i18next
 * loads itself). Fragments are applied in path order and win over the base.
 *
 * Jest cannot run import.meta.glob; jest.config.js maps this module to
 * jest/loadLocaleStub.js, which does the same merge with fs.
 */
import { mergeLocaleParts } from './mergeLocale.mjs';

const BASE = import.meta.glob('./*.json', { import: 'default' });
const FRAGMENTS = import.meta.glob('./fragments/*/*.json', { import: 'default' });

export function fragmentPathsFor(lang, paths = Object.keys(FRAGMENTS)) {
  return paths.filter((p) => p.endsWith(`/${lang}.json`)).sort();
}

export default async function loadLocale(lang) {
  const base = BASE[`./${lang}.json`];
  if (!base) throw new Error(`No locale file for "${lang}"`);
  const loaders = [base, ...fragmentPathsFor(lang).map((p) => FRAGMENTS[p])];
  const parts = await Promise.all(loaders.map((load) => load()));
  return mergeLocaleParts(parts);
}
